import React from "react";
import PrintState from "../interface/PrintState";
import AppSettingController from "../../../../Main/controller/AppSettingController";
import validateIP from "../../../../../utility/validateIp";
import i18n from "../../../../../i18n";

export default class PrintController {
    protected state: PrintState;
    protected setState: React.Dispatch<React.SetStateAction<PrintState>>;

    constructor(state: PrintState, setState: React.Dispatch<React.SetStateAction<PrintState>>) {
        this.state = state;
        this.setState = setState;
    }

    async addPrinter(e: any) {
        const numberRegex = /^-?\d+(\.\d+)?$/;
        e.preventDefault();
        if (!this.state.ip) return this.updateState({
            ...this.state,
            error: true,
            message: i18n.t("setting.error.printerIpRequired")
        });

        if (!validateIP(this.state.ip)) return this.updateState({
            ...this.state,
            error: true,
            message: i18n.t("setting.error.invalidPrinterIp")
        });

        if (!this.state.port || !numberRegex.test(this.state.port)) return this.updateState({
            ...this.state,
            error: true,
            message: i18n.t("setting.error.printerPortRequired")
        });

        this.setState({
            error: false,
            ip: "",
            port: "",
            name: "",
            message: ""
        })

        AppSettingController.addPrinter(
            this.state.ip,
            this.state.port,
            this.state.name,
        )
    }

    private updateState(state: object) {
        const newState = {...this.state, ...state};
        this.state = newState;
        this.setState(newState)
    }
}